import { startOfDay, subMinutes } from "date-fns";
import { IWorkCalendarDay } from "../types";

/**
 * Функция которая возвращает время начала дня в UTC-0, учитывая ЧП пользователя.
 * @param day День который нужно сбросить на начало
 * @param offset смещение ЧП пользователя
 * @returns Начало дня в UTC-0
 */
export const getStartDayTime = (day: Date, offset: number) => {    
  const date = startOfDay(new Date(day)); // Ищем начало дня
  return subMinutes(date, offset); // Вычитаем часовой пояс пользователя
};

export const isNonWorkingDay = (weekDayIndex: number, workCalendarDay: IWorkCalendarDay) => (
  weekDayIndex === 5 || weekDayIndex === 6 || workCalendarDay?.type === 'holiday' || workCalendarDay?.type === 'weekend'
);

export const getWeekDayIndex = (date: Date) => {
  const day = date?.getDay();
  return day === 0 ? 6 : day - 1;
};
